import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type ThicBundleContentState = {
    ThicBundleContent: any;
    loading: boolean;
    error: any;
}

const initialState: ThicBundleContentState = {
    ThicBundleContent: null,
    loading: false,
    error: null,
};

const host = window?.location?.host;
const file = "thic-bundle-content.json";

export const getThicBundleContent = createAsyncThunk(
    "get/thic-bundle/content",
    async () => {
        try {
            const response = await useFetchAemBrspdContents({
                [ApiUrls.aem_content]: `${file}?appName=${host}`,
            });
            return response?.data;
        } catch (error) {
            throw error;
        }
    }
);

const ThicBundleSlice = createSlice({
    name: "thic-bundle-content/Details",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getThicBundleContent.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(getThicBundleContent.fulfilled, (state, action) => {
            state.ThicBundleContent = action.payload;
            state.loading = false;
            state.error = null;
        })
        builder.addCase(getThicBundleContent.rejected, (state, action) => {
            errorConditionGTM(
                "BRSPD_Fiber_EC_Flow",
                "thic-bundle-content",
                action?.error?.message,
                action?.type
            );
            state.ThicBundleContent = null;
            state.loading = false;
            state.error = action.error;
        });
    },
});

export default ThicBundleSlice.reducer;